import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Input, Button } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import NashPresentationReporting from '../Reporting/NashPresentationReporting';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const EnachPresentationReporting = () => {
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [loanId, setLoanId] = useState("");
  const [filterType, setFilterType] = useState("");
  const [loading, setLoading] = useState(true);
  const [filtering, setFiltering] = useState(false);
  const [error, setError] = useState("");
  const today = new Date().toISOString().split("T")[0];


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    axiosInstance
      .get(URL.REPORTING_ENACH_PRESENTATION)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch data.");
        setLoading(false);
      });
  };

  const handleSearch = () => {
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (customerId) params.customerId = customerId;
    if (loanId) params.loanId = loanId;

    if (!fromDate && !toDate && !customerId && !loanId) {
      fetchData();
      return;
    }

    setFiltering(true);
    axiosInstance
      .get(URL.REPORTING_ENACH_PRESENTATION, { params })
      .then((res) => {
        setData(res.data);
        setFiltering(false);
      })
      .catch(() => {
        setError("Failed to fetch filtered data.");
        setFiltering(false);
      });
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ENACH Report");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "ENACH_Report.xlsx");
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const [year, month, day] = isoDate.split("T")[0].split("-");
    return `${day}-${month}-${year}`;
  };

  if (loading) return <Spinner />;
  if (error) return <Alert color="danger">{error}</Alert>;

  return (
    <>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "10px" }}>
        <div>
          <label style={{ fontSize: "12px", fontWeight: "500" }}>Filter By</label>
          <Input
            type="select"
            value={filterType}
            onChange={(e) => {
              setFilterType(e.target.value);
              setCustomerId("");
              setLoanId("");
            }}
            style={{ fontSize: "12px", fontWeight: "500" }}
          >
            <option value="">Select Filter</option>
            <option value="customerId">Customer ID</option>
            <option value="loanId">Loan ID</option>
          </Input>
        </div>

        {filterType === "customerId" && (
          <div>
            <label style={{ fontSize: "12px", fontWeight: "500" }}>Customer ID</label>
            <Input
              type="number"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              placeholder="Enter Customer ID"
              style={{ fontSize: "12px", fontWeight: "500" }}
            />
          </div>
        )}

        {filterType === "loanId" && (
          <div>
            <label style={{ fontSize: "12px", fontWeight: "500" }}>Loan ID</label>
            <Input
              type="number"
              value={loanId}
              onChange={(e) => setLoanId(e.target.value)}
              placeholder="Enter Loan ID"
              style={{ fontSize: "12px", fontWeight: "500" }}
            />
          </div>
        )}

      <div>
  <label style={{ fontSize: "12px", fontWeight: "500" }}>From Date</label>
  <Input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
    min={today}
    style={{ fontSize: "12px", fontWeight: "500" }}
  />
</div>

<div>
  <label style={{ fontSize: "12px", fontWeight: "500" }}>To Date</label>
  <Input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
    min={today}
    style={{ fontSize: "12px", fontWeight: "500" }}
  />
</div>
        <div style={{ alignSelf: "end" }}>
          <Button color="primary" onClick={handleSearch} disabled={filtering}>
            {filtering ? "Loading..." : "Search"}
          </Button>
        </div>

        <div style={{ alignSelf: "end" }}>
          <Button color="success" onClick={exportToExcel}>
            Export to Excel
          </Button>
        </div>
      </div>

      <Table bordered striped responsive hover style={{ border: "1px solid white" }}>
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Customer ID</th>
            <th>Loan ID</th>
            <th>Borrower Name</th>
            <th>EMI Number</th>
            <th>NACH Applied Date</th>
            <th>EMI Date</th>
            <th>EMI Outstanding</th>
            <th>Fee Outstanding</th>
            <th>Total Outstanding</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{row.customer_id}</td>
                <td>{row.loan_id}</td>
                <td>{row.borrower_name}</td>
                <td>{row.emi_number}</td>
                <td>{row.nach_applied_date?.split("T")[0]}</td>
                <td>{row.emi_date}</td>
                <td>{row.emi_outstanding}</td>
                <td>{row.fee_outstanding}</td>
                <td>{row.total_outstanding}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" style={{ textAlign: "center" }}>No data found.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};

export default EnachPresentationReporting;
